import styled from "styled-components";
import { BRAND } from "./Nav";

export default function Footer() {
  return (
    <Bar>
      <span>
        © {new Date().getFullYear()} {BRAND}
      </span>
      <span>Demo — ndërtuar nga ASites</span>
    </Bar>
  );
}

const Bar = styled.footer`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 26px clamp(20px, 5vw, 64px) calc(40px + env(safe-area-inset-bottom));

  @media (max-width: 560px) {
    flex-direction: column;
    gap: 8px;
  }
  font-size: 11px;
  letter-spacing: 0.1em;
  color: var(--ink-soft);
  border-top: 1px solid var(--line);
`;
